// extracted by mini-css-extract-plugin
export var boxItems = "_8x-1";
export var boxItemsLg = "_8x-2";
export var button = "_8x-7";
export var buttonHoverless = "_8x-9";
export var buttonLg = "_8x-8";
export var filterGroupBox = "_8x-0";
export var icon = "_8x-3";
export var iconSecondary = "_8x-6";
export var iconWrapper = "_8x-4";
export var iconWrapperLg = "_8x-5";
export var truncatedLabel = "_8x-a";